import React, { FC, useMemo, useState } from "react";
import Notifications from "components/Notifications";
import ReportsStats from "components/Reports/ReportsStats/reportsStats";
import ReversingDecisions from "components/ReversingDecisions";
import { thirtyDaysAgoDate } from "common/helpers/calculateDays";
import { useGetCompletedQuery } from "features/api/reports/reportsSlice";
import { useRole } from "hooks/useRole";
import { LocalStorageKey, useGetUserData } from "common/helpers/userData";
import { UserRole } from "../reportAssets/assets";

type Props = {
  children: JSX.Element;
};

const ReportsLayout: FC<Props> = ({ children }) => {
  const [startDate, setStartDate] = useState(thirtyDaysAgoDate);

  const role = useRole();
  const isControlCenter = role === UserRole.CONTROLCENTER;
  const startDateString = useMemo(() => {
    startDate.setUTCHours(0, 0, 0, 0);
    return startDate.toISOString();
  }, [startDate]);

  const endDateString = useMemo(() => {
    const date = new Date();
    date.setUTCHours(23, 59, 59, 999);
    return date.toISOString();
  }, []);

  const [selectedDatePeriod, setSelectedDatePeriod] = useState("monthly");
  const { data: completed, isLoadingCompleted } = useGetCompletedQuery({
    start: startDateString ?? startDateString,
    end: endDateString ?? endDateString,
    userBoId: useGetUserData(LocalStorageKey.UserId),
  });

  return (
    <div className="reportsContainer">
      <main
        className={`main spaceTop ${
          isControlCenter ? "controlCenterMain" : ""
        }`}
      >
        {children}
      </main>
      {!isControlCenter && (
        <div className="side spaceTop">
          <div className="side-container">
            <ReportsStats
              setStartDate={setStartDate}
              completedReports={completed}
              selectedDatePeriod={selectedDatePeriod}
              setSelectedDatePeriod={setSelectedDatePeriod}
            />
            <ReversingDecisions
              selectedDatePeriod={selectedDatePeriod}
              startDateString={startDateString}
              endDateString={endDateString}
            />
            <Notifications />
          </div>
        </div>
      )}
    </div>
  );
};

export default ReportsLayout;
